import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IAchivements } from 'app/shared/model/achivements.model';
import { getEntities as getAchivements } from 'app/entities/achivements/achivements.reducer';
import { IUserAchivements } from 'app/shared/model/user-achivements.model';
import { getEntity, updateEntity, createEntity, reset } from './user-achivements.reducer';

export const UserAchivementsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const achivements = useAppSelector(state => state.achivements.entities);
  const userAchivementsEntity = useAppSelector(state => state.userAchivements.entity);
  const loading = useAppSelector(state => state.userAchivements.loading);
  const updating = useAppSelector(state => state.userAchivements.updating);
  const updateSuccess = useAppSelector(state => state.userAchivements.updateSuccess);

  const handleClose = () => {
    navigate('/user-achivements' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
    dispatch(getAchivements({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...userAchivementsEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
      achivements: achivements.find(it => it.id.toString() === values.achivements.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...userAchivementsEntity,
          user: userAchivementsEntity?.user?.id,
          achivements: userAchivementsEntity?.achivements?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.userAchivements.home.createOrEditLabel" data-cy="UserAchivementsCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.userAchivements.home.createOrEditLabel">Create or edit a UserAchivements</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-achivements-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.userAchivements.fileName')}
                id="user-achivements-fileName"
                name="fileName"
                data-cy="fileName"
                type="text"
              />
              <ValidatedField
                id="user-achivements-user"
                name="user"
                data-cy="user"
                label={translate('fivePlusApp.userAchivements.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="user-achivements-achivements"
                name="achivements"
                data-cy="achivements"
                label={translate('fivePlusApp.userAchivements.achivements')}
                type="select"
              >
                <option value="" key="0" />
                {achivements
                  ? achivements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-achivements" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserAchivementsUpdate;
